import { render, staticRenderFns } from "./WebsocketTestButton.vue?vue&type=template&id=95e6ae90&"
import script from "./WebsocketTestButton.vue?vue&type=script&lang=js&"
export * from "./WebsocketTestButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports